import React from "react"

import { ProfileDeleteOverlay } from "./ProfileDeleteOverlay"
import { useProfileDeleteOverlayModel } from "./model/useProfileDeleteOverlayModel"

export const ProfileDeleteOverlayConnector = React.memo(() => {
  return <ProfileDeleteOverlay {...useProfileDeleteOverlayModel()} />
})

declare module "shared/context/overlay/registry" {
  interface OverlayPayloadRegistry {
    PROFILE_DELETE_REQUEST_CODE_OVERLAY: null
  }
}
